import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

import canUseDOM from '../../util/canUseDOM';

const getScrollPosition = () => {
  return { x: window.scrollX, y: window.scrollY };
};

const useScrollPosition = (throttleAmount = 100) => {
  const [scrollPos, setScrollPos] = useState({ x: 0, y: 0 });

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!canUseDOM) {
      return null;
    }
    setScrollPos(getScrollPosition());

    const handleScroll = throttle(() => {
      setScrollPos(getScrollPosition());
    }, throttleAmount);

    // Bind lisenter
    window.addEventListener('scroll', handleScroll);
    // Unbind listener on Unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollPos;
};

export default useScrollPosition;
